import {select} from '@ngneat/elf';
import {
  getExecutionLinesDataSource,
  getExecutionLinesTotalDataSource,
} from '@store/invoices/executionLines/executionLine.requests';
import {executionLineStore} from '@store/invoices/executionLines/executionLine.store';
import {deleteEntities, getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {readyForInvoicingKey} from '@screens/admin/invoices/executions/Executions.tab';

export class ExecutionLineQuery {
  store = executionLineStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));


  filters = this.store.getValue().filters;

  executionLines$ = getExecutionLinesDataSource.data$();
  executionLinesTotal$ = getExecutionLinesTotalDataSource.data$();

  selectedExecutionLines$ = this.store.pipe(
    selectManyByPredicate((executionLineUi) => executionLineUi.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedExecutionLine() {
    return this.store.query(getAllEntitiesApply({
      mapEntity: (e) => e.id,
      filterEntity: (e) => e.selected,
      ref: UIEntitiesRef,
    }));
  }

  get selectedExecutionLineByExecutionId() {
    return this.store.query(getAllEntitiesApply({
      mapEntity: (e) => e,
      filterEntity: (e) => e.selected,
      ref: UIEntitiesRef,
    }));
  }

  deselectAll(ids: number[]) {
    return this.store.update(
        deleteEntities(ids)
    );
  }

  getExecutionLinesReadyForInvoicing(): { id: number; totalSell: number; totalBuy: number }[] {
    return JSON.parse(localStorage.getItem(readyForInvoicingKey) || '[]');
  }

  getExecutionLinesReadyForInvoicingIds() {
    return JSON.parse(localStorage.getItem(readyForInvoicingKey) || '[]').map(el => el.id);
  }
}

export const executionLineQuery = new ExecutionLineQuery();
